import { createReducer, on, Action } from '@ngrx/store';
import * as DiscoveryFlightsActions from '../actions/discovery-flights.actions';
import { DiscoveryFlight } from '@fsp-lib/discovery-flights';

export interface State {
  // Flight data
  selectedFlightDetails: DiscoveryFlight | null;
  isLoadingFlightDetails: boolean;
  error: string | null; // Replace with proper confirmation interface
}

export const initialState: State = {
  selectedFlightDetails: null,
  isLoadingFlightDetails: false,
  error: null,
};

const discoveryFlightsReducer = createReducer(
  initialState,

  // Load Flight Details
  on(DiscoveryFlightsActions.clearFlightDetails, (state) => ({
    ...state,
    selectedFlightDetails: null,
    isLoadingFlightDetails: false,
    error: null,
  })),

  on(DiscoveryFlightsActions.loadFlightDetails, (state) => ({
    ...state,
    isLoadingFlightDetails: true,
    error: null,
  })),

  on(
    DiscoveryFlightsActions.loadFlightDetailsSuccess,
    (state, { flightDetails }) => ({
      ...state,
      selectedFlightDetails: flightDetails,
      isLoadingFlightDetails: false,
      error: null,
    }),
  ),

  on(DiscoveryFlightsActions.loadFlightDetailsFailure, (state, { error }) => ({
    ...state,
    isLoadingFlightDetails: false,
    error,
    selectedFlightDetails: null,
  })),

  // Clear Actions
  on(DiscoveryFlightsActions.clearErrors, (state) => ({
    ...state,
    error: null,
  })),

  on(DiscoveryFlightsActions.resetState, () => initialState),
);

export function reducer(state: State | undefined, action: Action) {
  return discoveryFlightsReducer(state, action);
}
